import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import { ReactNode } from 'react'

export function IconBox({ icon, color, bgcolor }: { icon: ReactNode; color?: string; bgcolor?: string }) {
  const theme = useTheme()
  return (
    <Box
      display="flex"
      color={color || theme.palette.common.white}
      bgcolor={bgcolor || theme.palette.primary.light}
      borderRadius={theme.radius.S}
      padding={theme.spacing.M}
      height={theme.size[14]}
      width={theme.size[14]}
      justifyContent="center"
      alignItems="center"
    >
      {icon}
    </Box>
  )
}
